import { useContext } from 'react';
import NavbarLogo from './NavbarLogo';
import MobileMenuButton from './MobileMenuButton';
import LoginButton from './LoginButton';
import ThemeToggle from './ThemeToggle';
import UserProfileDropdown from './UserProfileDropdown';
import { AuthContext } from '../../../../../context/AuthContext';
import styles from './NavbarContent.module.css';

const NavbarContent = () => {
    const { isAuthenticated } = useContext(AuthContext);

    return (
        <div className={styles.navbarContent}>
            <NavbarLogo />
            <div
                role="presentation"
                className={styles.navbarPlaceholder}
            >
                <div className={styles.placeholderOverlay}></div>
            </div>
            <MobileMenuButton />
            <div
                role="presentation"
                className={styles.navbarActions}
            >
                <div className={styles.actionsOverlay}></div>
                <ThemeToggle />
                {isAuthenticated ? (
                    <UserProfileDropdown />
                ) : (
                    <LoginButton />
                )}
                {/* <CartIcon /> */}
            </div>
            <div className={styles.navbarSpacer}></div>
        </div>
    );
};

export default NavbarContent;
